<template>
  <v-simple-table v-if="statisticInfo" class="mt-2 mb-2"  dense>
    <template v-slot:default>
      <thead>
      <tr>
        <th v-for="(item, index) in header" :key="index" class="text-left">
          {{ item }}
        </th>
      </tr>
      </thead>
      <tbody>
      <tr>
        <td>{{ statisticInfo.statisticAt }}</td>
        <td>{{ statisticInfo.playsOnDevices }}</td>
        <td>{{ statisticInfo.blockedOnDevices }}</td>
        <td>{{ statisticInfo.dateBudgetFinished }}</td>
        <td>{{ statisticInfo.mostPlayed }}</td>
        <td>{{ statisticInfo.leastPlayed }}</td>
        <td>{{ statisticInfo.playoutsYesterday }}</td>
      </tr>
      </tbody>
    </template>
  </v-simple-table>
  <div v-else>
    {{ $t('display/advert:overview.expanded-field.no-statistic') }}
  </div>
</template>

<script>
import AdvertService from '@/modules/display/services/advert-service';

export default {
  name: 'ExpandedField',
  props: {
    item: {}
  },
  computed: {
    header() {
      return [
        this.$t('display/advert:overview.expanded-field.generated-at'),
        this.$t('display/advert:overview.expanded-field.plays-on'),
        this.$t('display/advert:overview.expanded-field.blocked-on'),
        this.$t('display/advert:overview.expanded-field.finished-budget'),
        this.$t('display/advert:overview.expanded-field.most-played'),
        this.$t('display/advert:overview.expanded-field.least-played'),
        this.$t('display/advert:overview.expanded-field.y-playouts')
      ]
    }

  },
  data() {
    return {
      statisticInfo: null
    }

  },
  created() {
    AdvertService.getStatistic(this.item.id,
      (response) => {
        this.statisticInfo = response.data;
      }
    )
  }
}
</script>